module.exports = __webpack_public_path__ + "img/cloud5.df1459a1.png";